import { addLogLine } from './log';
type fetchParsedResponse = {
    success: boolean,
    successResponseObj: object,
    errorResponseStr: string,
}
// Not catching fetch error here, because we want to let the caller handle it
export async function makeGetRequestHandleResponse(getURL: string) : Promise<fetchParsedResponse> {
    const getResponse = await fetch(getURL);
    if (getResponse.status !== 200) {
        // Error
        addLogLine('Fetch to: ' + getURL + ' - status not 200, status: ' + getResponse.status + ', statusText: ' + getResponse.statusText);
        const errorText = await getResponse.text();
        const errorDataStr = JSON.stringify({
            'responseStatus': getResponse.status,
            'responseStatusText': getResponse.statusText,
            'responseText': errorText,
        });
        return {
            success: false,
            errorResponseStr: errorDataStr,
            successResponseObj: {},
        }
    }
    // else
    const responseJson = await getResponse.json();
    if (!responseJson) {
        throw new Error('responseJson is empty - Unexpected behavior!');
    }
    return {
        success: true,
        successResponseObj: responseJson,
        errorResponseStr: '',
    }
}